import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "restAddress",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6 p-float-label" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "solrCollection",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12 p-float-label" }
const _hoisted_9 = {
  for: "restRequestBody",
  class: "kn-material-input-label"
}
const _hoisted_10 = {
  key: 0,
  class: "p-field p-col-12 p-float-label"
}
const _hoisted_11 = {
  for: "solrFieldList",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")
  const _component_RequestHeadersTable = _resolveComponent("RequestHeadersTable")
  const _component_QueryParamTable = _resolveComponent("QueryParamTable")
  const _component_FacetInfoDialog = _resolveComponent("FacetInfoDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                id: "restAddress",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.restAddress.$invalid && _ctx.v$.dataset.restAddress.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.dataset.restAddress.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.restAddress.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.restAddress.$touch())),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.datasetManagement.restAddress')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.restAddress,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.restAddress') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "solrCollection",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.solrCollection.$invalid && _ctx.v$.dataset.solrCollection.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.dataset.solrCollection.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataset.solrCollection.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.dataset.solrCollection.$touch())),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.datasetManagement.solrCollection')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.solrCollection,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.solrCollection') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_InputText, {
              id: "restRequestBody",
              class: "kn-material-input",
              type: "text",
              maxLength: "2000",
              modelValue: _ctx.dataset.restRequestBody,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataset.restRequestBody = $event)),
              modelModifiers: { trim: true },
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('kpi.measureDefinition.query')), 1)
          ]),
          (_ctx.dataset.solrType == 'DOCUMENTS')
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_InputText, {
                  id: "solrFieldList",
                  class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.dataset.solrFieldList.$invalid && _ctx.v$.dataset.solrFieldList.$dirty
                        }],
                  type: "text",
                  modelValue: _ctx.v$.dataset.solrFieldList.$model,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.dataset.solrFieldList.$model = $event)),
                  modelModifiers: { trim: true },
                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.dataset.solrFieldList.$touch())),
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('touched')))
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.datasetManagement.solrFieldList')) + " * ", 1),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.solrFieldList,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.solrFieldList') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_RequestHeadersTable, { selectedDataset: _ctx.selectedDataset }, null, 8, ["selectedDataset"]),
    _createVNode(_component_QueryParamTable, { selectedDataset: _ctx.selectedDataset }, null, 8, ["selectedDataset"]),
    _createVNode(_component_FacetInfoDialog, {
      visible: _ctx.facetQueryHelpVisible,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.facetQueryHelpVisible = false))
    }, null, 8, ["visible"])
  ], 64))
}